module.exports = __webpack_public_path__ + "static/007169-2fae40bc1ad352702f5f2d34cf4da1ac.jpg";